__turbopack_context__.v({
  "dualCol": "TechnicalSpecifications-module__b6c9DG__dualCol",
  "listCol": "TechnicalSpecifications-module__b6c9DG__listCol",
  "pCol": "TechnicalSpecifications-module__b6c9DG__pCol",
  "root": "TechnicalSpecifications-module__b6c9DG__root",
  "title": "TechnicalSpecifications-module__b6c9DG__title",
});
